<template>
  <div id="container">
    <v-container wrap>
      <v-dialog v-model="enable" max-width="500" persistent>
        <v-card>
          <v-card-text style="text-align: center">
            <div
              class="mb-4"
              :style="{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }"
            >
              <div
                :style="{
                  borderRadius: '50%',
                  backgroundColor: '#8fe5c0',
                  height: '65px',
                  width: '65px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }"
              >
                <v-icon large color="#155d45">done</v-icon>
              </div>
            </div>
            <p style="font-size: 1.5rem; font-weight: bold">
              Horario actualizado con éxito
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      enable: this.value,
    };
  },
  watch: {
    value() {
      this.enable = this.value;
    },
  },
};
</script>

<style>
</style>